import React,{useEffect,useState} from "react";
import { Tab, Nav } from "react-bootstrap";
import VehicleUsageConfig from "./config-tabs/VehicleUsage";
import { useDispatch, useSelector } from 'react-redux';
import {getMasterConfig} from '../../store/slices/common';
import {VEHICLE_USAGE_PASSENGER,VEHICLE_USAGE_COMMERCIAL,VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL} from '../../config/constant'
import {getInsurancePartnerById} from '../../store/slices/partner'
import { useParams } from "react-router-dom";

const ConfigurationPanel = (props: any) => {
  const { id } = useParams();
  const dispatch: any = useDispatch();
  const commonState = useSelector((state: any) => state.common);

  const [vehicleTypeList, setVehicleTypeList] = useState<any>([]);
  const [engineCapacity, setEngineCapacity] = useState<any>([]);
  const [commisionRate, setcommisionRate] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<string>("first");
  const [insurancePartnerName, setInsurancePartnerName] = useState("");
  const [insuranceType, setinsuranceType] = useState<any>([]);

  useEffect(() => {
      const getMasterConfigData = async () => {
          if (Object.keys(commonState.common).length === 0) {
              const response: any = await dispatch(getMasterConfig());
              setVehicleTypeList(response?.data?.vehicle_type);
              setEngineCapacity(response?.data?.engine_capacity)
              setcommisionRate(response?.data?.commision_rate)
              setinsuranceType(response?.data?.insurance_type)
          } else {
              setVehicleTypeList(commonState.common.vehicle_type);
              setEngineCapacity(commonState.common.engine_capacity)
              setcommisionRate(commonState.common.commision_rate)
              setinsuranceType(commonState.common.insurance_type)
          }
      }
      getMasterConfigData();
      // eslint-disable-next-line
  }, [dispatch, commonState]);

  useEffect(() => {
      const getPartnerData = async () => {
        const response: any = await getInsurancePartnerById({partner_id:id});
        setInsurancePartnerName(response?.[0]?.name)
      }
      getPartnerData();
      // eslint-disable-next-line
  }, [id]);
  

  // Filter based on tab
  const getFilteredVehicleTypes = () => {
    if (activeTab === "first") return vehicleTypeList?.filter((v:any) => v.vehicle_usage === VEHICLE_USAGE_PASSENGER);
    if (activeTab === "second") return vehicleTypeList?.filter((v:any) => v.vehicle_usage === VEHICLE_USAGE_COMMERCIAL);
    return [];
  };

  const getMortorCycleId = ():number => {
    if (activeTab === "first") return VEHICLE_TYPE_MOTORCYCLE;
    if (activeTab === "second") return VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL;
    return 0;
  }

  return (
    <div className="container-fluid">
      <div className="top-heading confing-top-heading">
        <h1>Configuration Panel</h1>
      </div>
      <div className="top-heading confing-top-heading">
        <h1 style={{ color: '#0bbddd' }}>{insurancePartnerName}</h1>
      </div>
      <div className="config-panel-outer">
        <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={(k) => setActiveTab(k || "first")}>
          <Nav variant="pills" className="flex-column tab-line">
            <div className="tab-list">
              <Nav.Item>
                <Nav.Link eventKey="first">Private</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Commercial</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="third">Luxury Category</Nav.Link>
              </Nav.Item>
            </div>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey={activeTab}>
              <VehicleUsageConfig vehicleTypes={getFilteredVehicleTypes()} engineCapacity={engineCapacity}
                commisionRate={commisionRate} insuranceType={insuranceType} motorCycleId={getMortorCycleId()} activeTab={activeTab}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default ConfigurationPanel;
